import React from "react"
import { useTranslation } from "react-i18next"

import {
  Content,
  Title,
  Description,
  Wrapper,
} from "components/Subscription/Modal/Create/elements"
import Form from "components/Subscription/Modal/Create/MobilePayment/Form"
import { SUBSCRIPTION_MOBILE_PHONE_NUMBER } from "config"
import { ZlickAuthRequestValues } from "types"

type Props = {
  subscription_id: string
  onSubmit: (values: ZlickAuthRequestValues) => void
}

const SubscriptionMobilePayment = ({ subscription_id, onSubmit }: Props) => {
  const { t } = useTranslation()

  const handleSubmit = (values: ZlickAuthRequestValues) => {
    onSubmit(values)
  }

  return (
    <Content>
      <Title variant="h4">
        {t("features.subscription.steps.mobile.title")}
      </Title>
      <Description variant="h6">
        {t("features.subscription.steps.mobile.description")}
      </Description>
      <Wrapper>
        <Form
          initialValues={{
            subscription_id,
            phone: SUBSCRIPTION_MOBILE_PHONE_NUMBER,
          }}
          onSubmit={handleSubmit}
        />
      </Wrapper>
    </Content>
  )
}

export default SubscriptionMobilePayment
